var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4545 5C17.4545 6.10457 15.0125 7 12 7C8.98754 7 6.54545 6.10457 6.54545 5C6.54545 3.89543 8.98754 3 12 3C15.0125 3 17.4545 3.89543 17.4545 5ZM6.35867 12.6097C3.72689 13.2402 2 14.2995 2 15.5C2 17.433 6.47715 19 12 19C17.5228 19 22 17.433 22 15.5C22 14.2995 20.2731 13.2402 17.6413 12.6097C17.5463 12.6466 17.4497 12.6822 17.3519 12.7164C15.9384 13.2112 14.0463 13.5 12 13.5C9.95366 13.5 8.06153 13.2112 6.64805 12.7164C6.55024 12.6822 6.4537 12.6466 6.35867 12.6097ZM4.72727 9.99992C4.72727 8.99093 6.46614 8.12155 8.96996 7.72657C9.88288 7.90333 10.9168 7.99992 12 7.99992C13.0832 7.99992 14.1171 7.90333 15.03 7.72656C17.5338 8.12154 19.2727 8.99093 19.2727 9.99992C19.2727 11.3806 16.0166 12.4999 12 12.4999C7.98338 12.4999 4.72727 11.3806 4.72727 9.99992Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBal);
export default __webpack_public_path__ + "static/media/bal.b3ae53493013ad06ebd75b3f7d6e9653.svg";
export { ForwardRef as ReactComponent };